import { gql } from '@apollo/client';

export const GET_ALL_APPOINTMENTS_SLOTS_OF_MONTH = gql`
  query getAllAppointmentsSlotsOfMonth(
    $companyId: String!
    $month: String!
    $serviceId: String!
  ) {
    getAllAppointmentsSlotsOfMonth(
      companyId: $companyId
      month: $month
      serviceId: $serviceId
    )
  }
`;

export const GET_ALL_APPOINTMENTS_SLOTS_OF_DAY = gql`
  query getAllAppointmentsSlotsOfDay(
    $companyId: String!
    $day: String!
    $serviceId: String!
  ) {
    getAllAppointmentsSlotsOfDay(
      companyId: $companyId
      day: $day
      serviceId: $serviceId
    ) {
      startHour
      endHour
    }
  }
`;

export const CANCEL_APPOINTMENT = gql`
  mutation cancelAppointment($appointmentId: String!, $companyId: String!) {
    cancelAppointment(appointmentId: $appointmentId, companyId: $companyId) {
      id
      status
      dayOfAppointment
      hourOfAppointment
      Client {
        id
        name
        lastName
        birthday
        email
        phoneNumber
        ext
      }
      service {
        id
        name
        durationInSec
      }
      Company {
        id
        timeZone
      }
    }
  }
`;

export const START_APPOINTMENT = gql`
  mutation startAppointment($appointmentId: String!, $companyId: String!) {
    startAppointment(appointmentId: $appointmentId, companyId: $companyId) {
      id
      status
      dayOfAppointment
      hourOfAppointment
      Client {
        id
        name
        lastName
        birthday
        email
        phoneNumber
        ext
      }
      service {
        id
        name
        durationInSec
      }
      Company {
        id
        timeZone
      }
    }
  }
`;

export const COMPLETE_APPOINTMENT = gql`
  mutation finishAppointment(
    $appointmentId: String!
    $companyId: String!
    $finalComment: String
  ) {
    finishAppointment(
      appointmentId: $appointmentId
      companyId: $companyId
      finalComment: $finalComment
    ) {
      id
      status
      dayOfAppointment
      hourOfAppointment
      Client {
        id
        name
        lastName
        birthday
        email
        phoneNumber
        ext
      }
      service {
        id
        name
        durationInSec
      }
      Company {
        id
        timeZone
      }
    }
  }
`;

export const GET_ALL_APPOINTMENTS_OF_A_DAY = gql`
  query getAllAppointmentsOfADay(
    $companyId: String!
    $day: String!
    $range: String!
  ) {
    getAllAppointmentsOfADay(companyId: $companyId, day: $day, range: $range) {
      id
      dayOfAppointment
      hourOfAppointment
      status
      Client {
        id
        name
        lastName
        birthday
        email
        phoneNumber
        ext
      }
      service {
        id
        name
        durationInSec
      }
      Company {
        id
        timeZone
      }
    }
  }
`;

export const CREATE_APPOINTMENT = gql`
  mutation createAppointment(
    $hourOfAppointment: String!
    $dayOfAppointment: String!
    $serviceId: String!
    $companyId: String!
    $clientId: String!
    $initialComment: String
  ) {
    createAppointment(
      hourOfAppointment: $hourOfAppointment
      dayOfAppointment: $dayOfAppointment
      serviceId: $serviceId
      companyId: $companyId
      clientId: $clientId
      initialComment: $initialComment
    ) {
      id
    }
  }
`;

export const GET_ALL_APPOINTMENTS_GROUPED_BY_DAY = gql`
  query GET_ALL_APPOINTMENTS_GROUPED_BY_DAY(
    $companyId: String!
    $page: Int!
    $limit: Int!
  ) {
    getAllAppointmentsGroupedByDay(
      companyId: $companyId
      page: $page
      limit: $limit
    ) {
      pages
      groups {
        day
        appointments {
          id
          dayOfAppointment
          hourOfAppointment
          status
          Client {
            id
            name
            lastName
            birthday
            email
            phoneNumber
            ext
          }
          service {
            id
            name
            durationInSec
          }
          Company {
            id
          }
        }
      }
    }
  }
`;

export const RESCHEDULE_APPOINTMENT = gql`
  mutation rescheduleAppointment(
    $appointmentId: String!
    $dayOfAppointment: String!
    $hourOfAppointment: String!
  ) {
    rescheduleAppointment(
      appointmentId: $appointmentId
      dayOfAppointment: $dayOfAppointment
      hourOfAppointment: $hourOfAppointment
    ) {
      id
      dayOfAppointment
      hourOfAppointment
      status
      Client {
        id
        name
        lastName
        birthday
        email
        phoneNumber
        ext
      }
      service {
        id
        name
        durationInSec
      }
      Company {
        id
        timeZone
      }
    }
  }
`;
